// extracted by mini-css-extract-plugin
export var textInput = "_me-0";